import type { ItemSection } from './itemMovements'

export type SubsNavigationSection = ItemSection
export type PagingToken = number | 'gap'
export type PagingTarget = number | 'previous' | 'next'

export type PagingModel = {
  currentPage: number
  totalPages: number
  tokens: PagingToken[]
  previousDisabled: boolean
  nextDisabled: boolean
}

export type SubsNavigationAction =
  | { action: 'load-more'; parentElId: number }
  | { action: 'refresh' }
  | { action: 'set-page'; page: PagingTarget }
  | { action: 'switch-section'; mode: string }

export function normalizeSubsSection(section: SubsNavigationSection | 0 | 1): 0 | 1 {
  return section === 'submsges' || section === 1 ? 1 : 0
}

export function createPagingModel(currentPage = 1, totalPages = 1): PagingModel {
  const total = Math.max(1, Math.floor(totalPages || 1))
  const current = Math.min(Math.max(1, Math.floor(currentPage || 1)), total)
  let tokens: PagingToken[]

  if (total <= 3) tokens = Array.from({ length: total }, (_, index) => index + 1)
  else if (total === 4) tokens = current >= 3 ? [1, 'gap', 3, 4] : [1, 2, 'gap', 4]
  else if (current <= 2) tokens = [1, 2, 'gap', total]
  else if (current >= total - 1) tokens = [1, 'gap', total - 1, total]
  else tokens = [1, 'gap', current, current + 1, 'gap', total]

  return {
    currentPage: current,
    totalPages: total,
    tokens,
    previousDisabled: current <= 1,
    nextDisabled: current >= total,
  }
}

export function isPagingTargetDisabled(model: PagingModel, page: PagingTarget): boolean {
  if (page === 'previous') return model.previousDisabled
  if (page === 'next') return model.nextDisabled
  return page === model.currentPage || page < 1 || page > model.totalPages
}
